<template>
  <div :class="[style_div_column, space]">
    <label
      :for="inputName"
      style="
        margin-bottom: 7px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: var(--black-medium);
      "
      >{{ inputLabel }}</label
    >
    <div
      class="d-flex justify-content-between align-items-center w-100"
      style="
        background-color: var(--grey-light);
        height: 42px;
        border-radius: 4px;
      "
    >
      <input
        :id="inputId"
        class="border-0 w-100 h-100"
        :type="computedInputType"
        v-model="dynamicValue"
        :required="required"
        :disabled="disabled"
        :name="inputName"
        style="background-color: transparent; outline: none; padding-left: 18px"
        @input="$emit('isValid')"
      />
      <div v-if="!inputTypeNotValidation">
        <img
          v-if="inputType === 'text'"
          :src="require('@/assets/images/svg/ícone-ver-senha.svg')"
          alt=""
          style="margin-right: 18px"
          @click="$emit('clickVerSenha')"
        />
        <img
          v-else-if="inputType === 'password'"
          :src="require('@/assets/images/svg/ícone-ocultar-senha.svg')"
          alt=""
          style="margin-right: 18px"
          @click="$emit('clickVerSenha')"
        />
      </div>
      <IconValidation v-if="!justView" :value="dynamicValue" :show="isValid" />
    </div>
  </div>
</template>
<script>
import IconValidation from "@/components/IconValidation.vue";
export default {
  name: "Input",
  components: { IconValidation },
  data() {
    return {
      computedInputType: "",
      dynamicValue: "",
    };
  },
  props: {
    inputValue: String || Number,
    inputType: {
      type: String,
      required: true,
    },
    required: Boolean,
    disabled: Boolean,
    inputName: String,
    inputLabel: {
      type: String || Number,
      required: true,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    style_div_column: {
      type: String,
      default:
        "d-flex flex-column justify-content-between align-items-start w-100",
    },
    inputId: String,
    inputTypeNotValidation: {
      type: Boolean,
      default: false,
    },
    justView: {
      type: Boolean,
      default: false,
    },
    space: String,
  },
  watch: {
    dynamicValue(newValue) {
      this.$emit("onUpdate", newValue);
    },
    inputValue: function (newValue) {
      if (this.dynamicValue !== newValue) {
        this.dynamicValue = newValue;
      }
    },
    inputType: function (newValue) {
      if (this.computedInputType !== newValue) {
        this.computedInputType = newValue;
      }
    },
    isValid: function (newValue) {
      if (this.isValid !== newValue) {
        this.isValid = newValue;
      }
    },
  },
  mounted() {
    this.computedInputType = this.inputType;
    this.dynamicValue = this.inputValue;
  },
};
</script>
<style scoped>
.input {
  outline: none;
}
</style>
